/* ICONS custom header drawer — extracted verbatim from
   sections/icons-navigation-bar.liquid (Phase 1). Behaviour unchanged. */
(function() {
    const openBtn = document.getElementById('ciMobileOpen');
    const closeBtn = document.getElementById('ciMobileClose');
    const drawer = document.getElementById('ciMobileDrawer');
    const body = document.body;
    const html = document.documentElement;

    if (!openBtn || !closeBtn || !drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      body.classList.add('menu-open');
      html.classList.add('ci-menu-open');

      /* El drawer completo es el contenedor desplazable; evita fallos de scroll anidado en Safari móvil. */
      requestAnimationFrame(function() {
        drawer.scrollTop = 0;
      });
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      body.classList.remove('menu-open');
      html.classList.remove('ci-menu-open');
    }

    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.setAttribute('aria-controls', 'ciMobileDrawer');
    drawer.setAttribute('aria-hidden', 'true');

    openBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    drawer.querySelectorAll('.drawer-anchor').forEach(function(anchor) {
      anchor.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('.ci-m-acc-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const isOpening = !this.classList.contains('active');
        const content = this.nextElementSibling;

        this.classList.toggle('active', isOpening);
        this.setAttribute('aria-expanded', isOpening ? 'true' : 'false');
        content.style.maxHeight = isOpening ? content.scrollHeight + 'px' : null;
      });
    });

    /* Recalcula los acordeones abiertos cuando cambia la altura útil del móvil. */
    window.addEventListener('resize', function() {
      drawer.querySelectorAll('.ci-m-acc-btn.active').forEach(function(btn) {
        const content = btn.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + 'px';
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  })();
